import { render, staticRenderFns } from "./ShellModifications.vue?vue&type=template&id=251510b8&scoped=true"
import script from "./ShellModifications.vue?vue&type=script&lang=ts"
export * from "./ShellModifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251510b8",
  null
  
)

export default component.exports